<template>
  <el-tooltip :disabled="!needTooltip" placement="bottom" effect="light" transition="el-zoom-in-top" :open-delay="300">
    <div slot="content" v-html="content" />
    <div class="tooltip-area">
      <expression-editor class="disabled border border-1 rounded-3" :value="code" :options="{ theme: 'elegant' }" />
    </div>
  </el-tooltip>
</template>

<script>
import ExpressionEditor from '../../code-editor/ExpressionEditor'

const MAX_EXPRESSION_CONTENT_LENGTH = 30

export default {
  name: 'ExpressionField',
  components: { ExpressionEditor },
  props: {
    content: {
      type: String,
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    code() {
      return this.needTooltip ? this.truncated : this.content
    },
    needTooltip() {
      return !this.inDetailView && this.content !== null && this.content.length > MAX_EXPRESSION_CONTENT_LENGTH
    },
    truncated() {
      return this.content.substring(0, MAX_EXPRESSION_CONTENT_LENGTH) + '...'
    },
  },
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
}
</style>
